import { post } from "@/utils/utils";
import moment from "moment";

const appointment = {
  state: {
    writeOffList: [],
    writeOffCode: "",
    boughtProductList: [],
    currentOrderDetails: []
  },
  mutations: {
    WRITE_OFF_LIST(state, data) {
      state.writeOffList = data.result.model;
      if (state.writeOffList.list && state.writeOffList.list.length) {
        state.writeOffList.list.forEach(v => {
          v.checkDateFormat = v.checkDate
            ? moment(v.checkDate).format("YYYY-MM-DD HH:mm:ss")
            : "";
        });
      }
    },
    WRITE_OFF_ORDER(state, data) {
      state.writeOffCode = data.result;
    },
    BOUGHT_PRODUCT_LIST(state, data) {
      state.boughtProductList = data.result;
    },
    CURRENT_ORDER_DETAILS(state, data) {
      state.currentOrderDetails = data.result;
    }
  },
  actions: {
    queryWriteOffList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/check_record_list`,
        name: "WRITE_OFF_LIST",
        params
      });
    },
    writeOffOrder({ commit }, params) {
      return post({
        commit,
        url: `/server-back/check_server`,
        name: "WRITE_OFF_ORDER",
        params
      });
    },
    queryBoughtProductList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/member_card_list`,
        name: "BOUGHT_PRODUCT_LIST",
        params
      });
    },
    queryCurrentOrderDetails({ commit }, params) {
      return post({
        commit,
        url: `/server-back/check_server_list`,
        name: "CURRENT_ORDER_DETAILS",
        params
      });
    }
  }
};

export default appointment;
